import { render, staticRenderFns } from "./AgencyEntrustment.vue?vue&type=template&id=6b6990d9&scoped=true&"
import script from "./AgencyEntrustment.vue?vue&type=script&lang=js&"
export * from "./AgencyEntrustment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6990d9",
  null
  
)

export default component.exports